import LayoutError from '@components/LayoutError';
import useError from 'hooks/useError';
import useLocale from 'hooks/useLocale';
import { useEffect } from 'react';

export const ErrorFallback = () => {
  const { setError } = useError();
  const translations = useLocale();

  useEffect(() => {
    setError({
      message: translations.generic.error.unhandledError.message,
      title: translations.generic.error.unhandledError.title,
    });
  }, []);

  return <LayoutError />;
};
